import {
    actionsMutationsUpdaters,
    actionsSubscriptionsUpdaters,
} from './actions'
import { agendasSubscriptionsUpdaters } from './agendas'
import {
    attachmentsSubscriptionsUpdaters,
    attachmentUpdaters,
} from './attachments'
import { chatMutationsUpdaters, chatSubscriptionsUpdaters } from './chat'
import {
    commentsMutationsUpdaters,
    commentsSubscriptionsUpdaters,
} from './comments'
import {
    decisionsMutationsUpdaters,
    decisionsSubscriptionsUpdaters,
} from './decisions'
import { groupsUpdaters } from './groups'
import {
    integrationsMutationUpdaters,
    integrationsSubscriptionUpdaters,
} from './integrations'
import { inviteUsersUpdaters } from './inviteUsers'
import { itemDetailsUpdaters } from './itemDetails'
import { meetingUpdaters, metingSubscriptionsUpdaters } from './meeting'
import { meetingsUpdaters } from './meetings'
import { momUpdaters } from './mom'
import { notesSubscriptionsUpdaters } from './notes'
import { pollSubscriptionsUpdaters, pollsMutationsUpdaters } from './polls'
import {
    summaryMutationsUpdaters,
    summarySubscriptionsUpdaters,
} from './summary'
import { tagsMutationsUpdaters, tagsSubscriptionsUpdaters } from './tags'
import { templateUpdaters } from './templates'
import {
    transcriptionsMutationsUpdaters,
    transcriptionsSubscriptionsUpdaters,
} from './transcriptions'
import { userMutationUpdaters } from './user'
import { countUsersUpdaters } from './userCount'

export const mutationUpdaters = {
    ...meetingsUpdaters,
    ...meetingUpdaters,
    ...groupsUpdaters,
    ...actionsMutationsUpdaters,
    ...attachmentUpdaters,
    ...itemDetailsUpdaters,
    ...templateUpdaters,
    ...inviteUsersUpdaters,
    ...decisionsMutationsUpdaters,
    ...momUpdaters,
    ...countUsersUpdaters,
    ...commentsMutationsUpdaters,
    ...tagsMutationsUpdaters,
    ...pollsMutationsUpdaters,
    ...integrationsMutationUpdaters,
    ...chatMutationsUpdaters,
    ...userMutationUpdaters,
    ...transcriptionsMutationsUpdaters,
    ...summaryMutationsUpdaters,
}

export const subscriptionUpdaters = {
    ...commentsSubscriptionsUpdaters,
    ...tagsSubscriptionsUpdaters,
    ...actionsSubscriptionsUpdaters,
    ...decisionsSubscriptionsUpdaters,
    ...agendasSubscriptionsUpdaters,
    ...notesSubscriptionsUpdaters,
    ...attachmentsSubscriptionsUpdaters,
    ...chatSubscriptionsUpdaters,
    ...pollSubscriptionsUpdaters,
    ...metingSubscriptionsUpdaters,
    ...integrationsSubscriptionUpdaters,
    ...transcriptionsSubscriptionsUpdaters,
    ...summarySubscriptionsUpdaters,
}
